import type { TranslationMessages } from '../../types';

export const badges: TranslationMessages = {
  title: 'Huy hiệu',
  subtitle: 'Xem huy hiệu thành tích và phần thưởng của bạn',
  earned_badges: 'Huy hiệu đã kiếm được',
  all_badges: 'Tất cả huy hiệu',
  badge_categories: 'Danh mục huy hiệu',
  attendance: 'Điểm danh',
  performance: 'Hiệu suất',
  teamwork: 'Làm việc nhóm',
  special: 'Đặc biệt',
  customer_service: 'Dịch vụ khách hàng',
  badge_rarity: 'Độ hiếm của huy hiệu',
  common: 'Phổ biến',
  uncommon: 'Không phổ biến',
  rare: 'Hiếm',
  epic: 'Sử thi',
  legendary: 'Huyền thoại',
  badge_details: 'Chi tiết huy hiệu',
  badge_criteria: 'Tiêu chí huy hiệu',
  point_reward: 'Phần thưởng điểm',
  earned_at: 'Kiếm được vào',
  awarded_by: 'Được trao bởi',
  no_badges_earned: 'Chưa kiếm được huy hiệu nào',
  filter_by_category: 'Lọc theo danh mục',
  filter_by_rarity: 'Lọc theo độ hiếm',
  apply_filter: 'Áp dụng bộ lọc',
  stats_total_badges: 'Tổng số huy hiệu',
  stats_available_badges: 'Huy hiệu có sẵn',
  stats_active_badges: 'Huy hiệu đang hoạt động',
  stats_currently_active: 'Hiện đang hoạt động',
  stats_legendary_badges: 'Huy hiệu huyền thoại',
  stats_highest_rarity: 'Độ hiếm cao nhất',
  stats_avg_points: 'Điểm trung bình yêu cầu',
  stats_points_to_earn: 'Điểm để kiếm',
  filters_title: 'Bộ lọc',
  search_label: 'Tìm kiếm',
  search_placeholder: 'Tìm kiếm huy hiệu...',
  category_label: 'Danh mục',
  all_categories: 'Tất cả danh mục',
  rarity_label: 'Độ hiếm',
  all_rarities: 'Tất cả độ hiếm',
  staff_badges_title: 'Huy hiệu nhân viên',
  items_count: '%{count} mục',
  no_badges_found: 'Không tìm thấy huy hiệu nào',
  no_badges_matching: 'Không tìm thấy huy hiệu nào khớp với tiêu chí của bạn',
  failed_load: 'Không thể tải huy hiệu',
  delete_success: 'Xóa huy hiệu thành công',
  delete_failed: 'Không thể xóa huy hiệu',
  points_label: 'điểm',
};
